import { useEffect, useRef } from "react";

import { modal } from "@/contexts";
import { emitter } from "@/utils/eventBus";

export const useExternalDisconnect = () => {
  const isInitialized = useRef(false);
  const hasWalletInfo = useRef(false);

  useEffect(() => {
    const unsubscribe = modal.subscribeWalletInfo((walletInfo) => {
      if (walletInfo) {
        hasWalletInfo.current = true;
      }

      if (!isInitialized.current) {
        isInitialized.current = true;
        return;
      }

      if (hasWalletInfo.current && !walletInfo) {
        console.log("[useExternalDisconnect]", { walletInfo });
        emitter.emit("LOGOUT", { reason: "Wallet disconnect" });
      }

      if (walletInfo) {
        hasWalletInfo.current = true;
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
};
